var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"clientContractContainer",staticClass:"fill-height pa-2 d-flex flex-column"},[_c('NonEditableContract',{staticClass:"mx-4",attrs:{"contract_info":_vm.contract,"contract_id":_vm.contract_id,"openCrmDetail":_vm.handleOpenCrmDetail,"condensed":_vm.condensed,"isVertical":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }